import axios from '../util/payrightAxios';
import encrypt from '../util/eCrypt';
import { SubmissionError } from 'redux-form';
import {
  CHANGE_PAYMENT_METHOD_SUCCESS,
  ADD_NEW_PAYMENT_METHOD_SUCCESS,
  ADD_PAYMENT_METHOD,
  CHANGE_PAYMENT_METHOD,
  PAY_NOW_BUTTON_CLICK,
  GO_BACK_TO_MAKE_PAYMENT,
  MAKE_PAYMENT_LOAD,
  CHANGE_CARD,
  PAYMENT_SUCCESS,
  API_FAILURE,
  SUBMITTING_PAYMENT,
  REMEDIATION_BANK_ACCOUNT_UPDATE_SUCCESS,
} from '../actions/types';
import history from '../history';
import Payment from 'payment';
import { FetchCustomerDetails } from './index';
import { eventTracking } from './eventTracking';
import { clearSelectedLoan, fetchLoans } from './loanActions';

export const handleAddCardSubmit = (values, dispatch) => {
  if (!values.cardNumber) {
    throw new SubmissionError({
      _error: 'Card No is required',
    });
  }

  if (!values.cvcNumber || typeof values.cvcNumber !== "string") {
    throw new SubmissionError({
      _error: 'CVN is required',
    });
  }

  // Encrpt values
  values.cardNumber = values.cardNumber.replace(/\s/g, '');
  values.number = encrypt(values.cardNumber);
  values.cardType = Payment.fns.cardType(values.cardNumber);

  values.cvn = encrypt(values.cvcNumber);
  values.cvcNumber = null;

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const customerId = localStorage.getItem('customerId');
  const authToken = localStorage.getItem('authToken');
  const url = `${apiBaseUrl}/customer/${customerId}/payment_method/Eway`;

  axios.defaults.headers.common['auth-token'] = authToken;

  const addCardRequestData = {
    encryptedCardNumber: values.number,
    encryptedCvv: values.cvn,
    expiryMonth: values.expiryMonth,
    expiryYear: values.expiryYear,
    cardHolder: values.fullName,
    cardProvider: values.cardType
  }

  return axios(url, {
    method: 'POST',
    data: addCardRequestData,
  }).then(function (response) {

    dispatch({ type: ADD_NEW_PAYMENT_METHOD_SUCCESS, payload: response.data });
    eventTracking({category: 'Payments', action: 'Added a new card'});

  }).catch((error) => {

    window.scrollTo(0, 0);
    throw new SubmissionError({
      _error: error.response.data.message,
    })
  });
}

export const handleCloudPaymentSubmit = (values, dispatch) => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const customerId = localStorage.getItem('customerId');
  const authToken = localStorage.getItem('authToken');
  const url = `${apiBaseUrl}/customer/${customerId}/payment_method/Cloud_Payment`;

  axios.defaults.headers.common['auth-token'] = authToken;

  return axios(url, {
    method: 'POST',
    data: values,
  }).then(function (response) {

    dispatch({ type: ADD_NEW_PAYMENT_METHOD_SUCCESS, payload: response.data });
    eventTracking({category: 'Payments', action: 'Added a new card'});

  }).catch((error) => {

    const validationsErrors = getErrorMessage(error.response.data.message, 'Please update the details and resubmit it again');

    window.scrollTo(0, 0);
    throw new SubmissionError(validationsErrors)
  });
}

export const handlePaymentSubmit = (values, dispatch) => {

  dispatch({ type: SUBMITTING_PAYMENT });
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const customerId = localStorage.getItem('customerId');
  const authToken = localStorage.getItem('authToken');
  const url = `${apiBaseUrl}/customer/${customerId}/payment`;

  axios.defaults.headers.common['auth-token'] = authToken;

  return axios(url, {
    method: 'POST',
    data: values,
  }).then(function (response) {
    dispatch(FetchCustomerDetails());
    
    if (values.hasOwnProperty('loanNumber')){
      dispatch(fetchLoans());
      dispatch(clearSelectedLoan());  
    }
    
    dispatch({ type: PAYMENT_SUCCESS, payload: response.data });
    eventTracking({category: 'Payments', action: 'Made a payment'});

  }).catch((error) => {

    const validationsErrors = getErrorMessage(error.response.data.message, 'Please check your card details or try another card.');

    dispatch({ type: API_FAILURE, payload: error });
    throw new SubmissionError(validationsErrors)
  });
}

export const handleChangeCardSubmit = (values, dispatch) => {

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const customerId = localStorage.getItem('customerId');
  const authToken = localStorage.getItem('authToken');
  const url = `${apiBaseUrl}/customer/${customerId}/payment_method/${values.paymentMethodId}`;

  axios.defaults.headers.common['auth-token'] = authToken;

  return axios(url, {
    method: 'PUT',
  }).then(function (response) {
 
      dispatch({ type: CHANGE_PAYMENT_METHOD_SUCCESS, payload: response.data });
      eventTracking({category: 'Payments', action: 'Changed the card'});
  }).catch((error) => {

    const validationsErrors = getErrorMessage(error.response.data.message, 'Please update the details and resubmit it again');

    window.scrollTo(0, 0);
    throw new SubmissionError(validationsErrors);
  });

}

export const handleRemediationBankAccountUpdate = (values, dispatch) => {

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const customerId = localStorage.getItem('customerId');
  const authToken = localStorage.getItem('authToken');
  const url = `${apiBaseUrl}/customer/${customerId}/remediation/bank_account`;

  axios.defaults.headers.common['auth-token'] = authToken;

  return axios(url, {
    method: 'PUT',
    data: values,
  }).then(function (response) {

      dispatch({ type: REMEDIATION_BANK_ACCOUNT_UPDATE_SUCCESS, payload: response.data });
      eventTracking({category: 'Remediation', action: 'Updated bank account details'});
  }).catch((error) => {

    const validationsErrors = getErrorMessage(error.response.data.message, 'Please update the details and resubmit it again');

    window.scrollTo(0, 0);
    throw new SubmissionError(validationsErrors);
  });

}

export const handleSelectCard = (paymentMethodId) => {


}

export const setCurrentSelectedCard = (paymentId) => {

  return {
    type: CHANGE_CARD,
    paymentId
  }

}

export const handleChangePaymentMethod = () => {
  return {
    type: CHANGE_PAYMENT_METHOD
  }
}

export const handleAddNewCard = () => {
  return {
    type: ADD_PAYMENT_METHOD
  }
}

export const handlePayNowClick = (paymentId) => {
  return {
    type: PAY_NOW_BUTTON_CLICK,
    paymentId
  }
}

export const handleGoBackToMakePayment = () => {
  return {
    type: GO_BACK_TO_MAKE_PAYMENT,
  }
}

export const makePaymentLoad = () => {
  return {
    type: MAKE_PAYMENT_LOAD
  }
}

export const goBackToDashBoard = () => {
  history.push('/dashboard');
}

export const goBackToMakePayment = () => {
  history.push('/payments');
}

export const goBackToMakeLoanPayment = () => {
  history.push('/loan-payments');
}

export const getErrorMessage = (response, errorMsg) => {
  try {
    let message = JSON.parse(response);
    message._error = errorMsg;
    return message;
  } catch (e) {
    return {
      _error: response
    };
  }
}
